export const NFL_POSITIONS: NFL_Position[] = ['QB', 'RB', 'WR', 'TE', 'D', 'K'];

export const LOCAL_STORAGE = {
  JWT_TOKEN: 'jwt_token',
};
